module.exports = __webpack_public_path__ + "static/car_product_6-7c396cfeb01f4a2790b5ba46e6305f80.jpg";